import * as React from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SvgQuickPaySolid = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 44,
  height: 44,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "m5.941 12.75-.112 1.5H4.475a.75.75 0 0 0 0 1.5h1.31a2.417 2.417 0 0 0 2.381 2h11.667c.737 0 1.34-.395 1.735-.83.376-.417.67-.99.681-1.554l.498-6.643a2.417 2.417 0 0 0-2.415-2.473H8.667a2.417 2.417 0 0 0-2.38 2H2.474a.75.75 0 0 0 0 1.5h3.691l-.112 1.5h-2.58a.75.75 0 0 0 0 1.5h2.467ZM7.75 10.5a.75.75 0 0 1 .75-.75H20a.75.75 0 0 1 0 1.5H8.5a.75.75 0 0 1-.75-.75Zm.989 3.5a.75.75 0 0 1 .75-.75h.01a.75.75 0 0 1 0 1.5h-.01a.75.75 0 0 1-.75-.75Zm3.51 0a.75.75 0 0 1 .75-.75h2a.75.75 0 1 1 0 1.5h-2a.75.75 0 0 1-.75-.75Z",
  fill: "currentColor"
})));

export { SvgQuickPaySolid as default };
